module.exports = __webpack_public_path__ + "img/Banner_Plattform_Felgen_innen.e6f29aa6.webp";